export const DORON_TO_YEN_RATE = 1.1

export const EXCLUDED_USERS_LIST = [
  'g74WXJJQmMNJBCUQb7vQeM0IRP02',
  'uNunhVG8w2fyWAJR8KzdhMnoXUa2',
  'H472eMJeVReL6rvk48ZfdALvVRn2',
  'tbim2ztgqtSfZgtK2zSUQseD85n2',
]
